import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { CareCoordinationExactPage } from "../models/care-coordination-sub-widget.model";
import { MemberPrepopulatedData } from "@core/model";
import { CareCoordinationSubWidget } from "../models";
import { CareCoordinationExactPageService } from "@core/service/care-coordination-exact-page.service";
import { CareCoordinationSubWidgetTab } from "../models/care-coordination-sub-widget.enum";

@Component({
    selector: 'app-case-management',
    templateUrl: './case-management.component.html',
    styleUrls: ['./case-management.component.scss'],
    standalone: false
})
export class CaseManagementComponent implements OnInit, OnChanges {
    @Input() memberId: string;
    @Input() tenantId: string;
    @Input() isSelectedTab!: boolean;
    @Input() scrollToWidget: CareCoordinationSubWidget;
    @Input() memberPrepopulatedData: MemberPrepopulatedData;
    router: any;
    memberRouterState: any;
    careCoordinationExactPageService: any;
    ngOnInit(): void {
        this.getCareCoordinationTabIndex();
    }

    ngOnChanges() {
        this.getCareCoordinationTabIndex();
    }

    //to-do needs-changes
    getExactPageData() {
        //todo
    }

    activeTabIndex = 0;
    loading = false;

    handleChange(event: { index: number }): void {
        this.activeTabIndex = event.index;
    }

    private getCareCoordinationTabIndex(): void {
        switch (this.scrollToWidget) {
            case CareCoordinationSubWidget.Referral:
                this.activeTabIndex = CareCoordinationSubWidgetTab.Referral;
                break;
        }
    }
}

